import store from '../store';
import router from '../router';

export function storeUser(user) {
    let data = { ...store.state.user, ...user };
    saveInSession('linklistUser', data);
    store.commit('setUser', data);
}

export function clearUser() {
    saveInSession('linklistUser', null);
    store.commit('setTrees', null);
    store.commit('setUser', null);
}

export function storeOrganisation(organisation) {
    let data = { ...store.organisation, ...organisation };
    saveInSession('linklistOrganisation', data);
    store.commit('setOrganisation', data);
    store.commit('setTrees', data.link_trees.data);
}

export function clearOrganisation() {
    saveInSession('linklistOrganisation', null);
    store.commit('setOrganisation', null);
}

function saveInSession(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function getDataFromSession() {
    let user = localStorage.getItem('linklistUser');
    let organisation = localStorage.getItem('linklistOrganisation');

    if (user !== undefined && user && user !== 'null') {
        user = JSON.parse(user);
        store.commit('setUser', user);
    }

    if (organisation !== undefined && organisation && organisation !== 'null') {
        organisation = JSON.parse(organisation);
        store.commit('setOrganisation', organisation);
        if (organisation.link_trees)
            store.commit('setTrees', organisation.link_trees.data);
    }
}

export function setupLoginGuard() {
    router.beforeEach((to, from, next) => {
        let loginRequired = false;
        const loggedInOnlyRoutes = [
            'Organisation',
            'Links',
            'New link',
            'Edit Link',
            'Settings',
            'Appearance',
        ];
        const publicEnabledRoutes = ['Login', 'Reset Password'];
        if (
            store.getters.user &&
            !Object.prototype.hasOwnProperty.call(to.query, 'logout')
        ) {
            if (to.name === 'Login' || to.name === 'Reset Password') {
                next({ name: 'Organisation' });
            } else {
                next();
            }
        } else {
            // block hidden routes
            if (loggedInOnlyRoutes.indexOf(to.name) >= 0) {
                if (publicEnabledRoutes.indexOf(to.name) >= 0) {
                    loginRequired = false;
                } else {
                    loginRequired = true;
                }
            }
            if (loginRequired) {
                next({ name: 'Login', params: { redirect: to.path } });
            } else {
                next();
            }
        }
    });
}
